var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDatasSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 34.645 32.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.75,32.18c-3.17,0-5.75-2.579-5.75-5.749V5.682C0,2.549,2.548,0,5.681,0h6.012c1.134,0,2.208.434,3.024,1.222l2.837,2.736c.409.395.948.612,1.515.612h6.155c3.17,0,5.749,2.579,5.749,5.749v1.494c0,.601-.486,1.087-1.087,1.087s-1.087-.486-1.087-1.087v-1.494c0-1.972-1.604-3.575-3.575-3.575h-6.155c-1.133,0-2.208-.434-3.024-1.222l-2.838-2.736c-.409-.395-.947-.612-1.515-.612h-6.012c-1.934,0-3.507,1.573-3.507,3.508v20.749c0,1.972,1.604,3.575,3.576,3.575.601,0,1.087.486,1.087,1.087s-.486,1.087-1.087,1.087Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.784,32.18H6.117c-1.218,0-2.336-.559-3.067-1.532-.732-.974-.957-2.203-.618-3.373l3.405-11.747c.698-2.41,2.939-4.094,5.449-4.094h19.072c1.36,0,2.609.623,3.426,1.711.817,1.087,1.068,2.46.689,3.767l-3.239,11.174c-.699,2.411-2.94,4.095-5.45,4.095ZM11.286,13.607c-1.548,0-2.93,1.038-3.361,2.525l-3.405,11.747c-.147.507-.049,1.04.268,1.462.317.422.801.664,1.329.664h19.667c1.548,0,2.931-1.039,3.362-2.526l3.239-11.174c.187-.644.063-1.319-.339-1.855-.402-.535-1.018-.843-1.688-.843H11.286Z",
    fill: "currentColor"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasSet);
export default __webpack_public_path__ + "static/media/DatasSet.d3f53d56.svg";
export { ForwardRef as ReactComponent };